module.exports = __webpack_public_path__ + "static/media/01.2263a6cc.mp3";